import React from "react";
import { DateTime } from "luxon";

interface CellDateProps {
  params: any;
  onClick?: () => void;
}

const CellDate = ({ params, onClick }: CellDateProps) => {
  const isoDate = params?.value;
  const formattedDate = isoDate
    ? DateTime.fromISO(isoDate).toFormat("dd LLL yyyy")
    : "--";

  return (
    <span
      style={{
        fontSize: "14px",
        color: "#333",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {formattedDate}
    </span>
  );
};

export default CellDate;
